
import { Component, Mixins } from "vue-property-decorator";
import { default as ImageDrawableObjectDrawerBase } from "./ImageDrawableObjectDrawerBase.vue";

@Component
export default class ClaioMediaDrawableObjectDrawerBase extends Mixins(ImageDrawableObjectDrawerBase) {
  // TODO: 必要な固有メンバ追加.
}
